import { Injectable } from '@angular/core';
import { DsnOperationMail } from 'app/models/dsn-operation-mail.model';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class DsnOperationMailService {


  dsnOperationMail: DsnOperationMail[];
  dsnOperationMailEditing: DsnOperationMail;

  private cachedFields: Observable<any>;

  private baseUrl = HttpClientService.BASE_MS_COMMON;

  constructor (
    private h: HttpClientService,
    private messageService: MessageService
  ) { }

  getAll(): Observable<DsnOperationMail[]> {
    return this.h.get(`${this.baseUrl}/dsn-operation-mail`)
      .map(res => {
        return this.dsnOperationMail = res;
      });
  }

  delete(record) {
    return this.h.delete(`${this.baseUrl}/dsn-operation-mail/` + record.id)
      .map(res => {
        this.dsnOperationMail.splice(this.dsnOperationMail.indexOf(record), 1);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'DsnOperationMail deleted'});
      });
  }

  post(newData) {
    return this.h.post(`${this.baseUrl}/dsn-operation-mail`, newData)
      .map(res => {
        newData.id = res.id;
        this.dsnOperationMail.push(newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData, id) {
    return this.h.put(`${this.baseUrl}/dsn-operation-mail/` + id, newData)
      .map(res => {
        Object.assign(this.dsnOperationMailEditing, newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get(this.baseUrl + '/schema/DsnOperationMailDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  recover(record){
    return this.h.put(`${this.baseUrl}/dsn-operation-mail/recover/` + record.id, {})
      .map(res => {
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'DsnOperationMail recovered'});
      });
  }



  getClusters(){
    return this.h.get(`/koncentro-loyalty/cluster`);
  }

  getFilteredClusters(cluster?){
    return this.h.get(`/koncentro-loyalty/cluster?description=${cluster}`)
  }

  getDivisionSalesNetwork(){
    return this.h.get(`${this.baseUrl}/division-sales-network/getDivisionSalesNetworkList`)
  }

  getServices(){
    return this.h.get(`${this.baseUrl}/service/services`)
  }

  getOperationId(){
    return this.h.get(`/koncentro-loyalty/params?param_group=DsnOperation`)
  }

  getDsnOperationMailByCluster(query: any) {
    return this.h.get(`${this.baseUrl}/dsn-operation-mail?description=${query}`)
  }

  duplicateDsnOperationMail(id?) {
    return this.h.post(`${this.baseUrl}/dsn-operation-mail/duplicate/${id}`, null)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/dsn-operation-mail/dsn-operation-mail.service.ts